"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _styles = require("./styles");

var _constants = require("./constants");

var ROW_AMOUNT_TO_SHOW = 0.25;
var ROWS_TO_DISPLAY = 6;

var reorder = function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);

  var _result$splice = result.splice(startIndex, 1),
      _result$splice2 = (0, _slicedToArray2.default)(_result$splice, 1),
      removed = _result$splice2[0];

  result.splice(endIndex, 0, removed);
  return result;
};

var DraggableItem = function DraggableItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      componentType = _ref.componentType;
  var ContentComponent = _constants.Components[componentType];

  var toRender = _react.default.createElement(ContentComponent, {
    item: item
  });

  return _react.default.createElement(_reactBeautifulDnd.Draggable, {
    draggableId: item.id,
    index: index
  }, function (provided) {
    return _react.default.createElement("div", (0, _extends2.default)({}, provided.draggableProps, provided.dragHandleProps, {
      ref: provided.innerRef,
      style: provided.draggableProps.style
    }), toRender);
  });
};

var DraggableList = function DraggableList(_ref2) {
  var items = _ref2.items,
      onChange = _ref2.onChange,
      itemHeight = _ref2.itemHeight,
      itemWidth = _ref2.itemWidth,
      componentType = _ref2.componentType;

  var _useState = (0, _react.useState)({
    items: items
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var totalHeight = state.items.length * itemHeight;
  var maxHeight = itemHeight * ROWS_TO_DISPLAY + itemHeight * ROW_AMOUNT_TO_SHOW;

  var onDragEnd = function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    var reorderedItems = reorder(state.items, result.source.index, result.destination.index);
    reorderedItems.forEach(function (item, index) {
      item.newPosition = index;
    });
    setState({
      items: reorderedItems
    });
    onChange(reorderedItems);
  };

  return _react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, _react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "list"
  }, function (provided) {
    var _state$items;

    return _react.default.createElement(_styles.DraggableListStyled, (0, _extends2.default)({}, provided.droppableProps, {
      ref: provided.innerRef,
      borderRadius: 3,
      borderColor: "guama",
      minHeight: itemHeight,
      maxHeight: maxHeight,
      height: totalHeight,
      width: itemWidth
    }), (_state$items = state.items) === null || _state$items === void 0 ? void 0 : _state$items.map(function (item, index) {
      return _react.default.createElement(DraggableItem, {
        item: item,
        index: index,
        key: item.id,
        componentType: componentType,
        width: itemWidth,
        height: "".concat(itemHeight, "px"),
        backgroundColor: "coco"
      });
    }), provided.placeholder);
  }));
};

exports.DraggableList = DraggableList;
DraggableList.defaultProps = {
  onChange: function onChange() {},
  itemHeight: 64,
  itemWidth: ['307px', '307px', '375px'],
  componentType: 'contentItemThumbnail'
};